import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UiComponentsModule } from '@shared/ui-components';
import { ToolTipDirective } from 'libs/common/src/lib/directives/tool-tip.directive';
import { NgChartsModule } from 'ng2-charts';
import { HomeComponent } from './dashboard/home.component';
import { CreateSubsciptionPlanComponent } from './super-admin/create-subsciption-plan/create-subsciption-plan.component';
import { CreateWorkspaceComponent } from './super-admin/create-workspace/create-workspace.component';
import { EditWorkspaceComponent } from './super-admin/edit-workspace/edit-workspace.component';
import { SubscriptionPlanComponent } from './super-admin/subscription-plan/subscription-plan.component';
import { SuperAdminDashboardComponent } from './super-admin/super-admin-dashboard/super-admin-dashboard.component';
import { WorkspaceDetailsComponent } from './super-admin/workspace-details/workspace-details.component';
import { WorkspaceInsightsComponent } from './super-admin/workspace-insights/workspace-insights.component';

@NgModule({
  declarations: [ToolTipDirective, HomeComponent, SuperAdminDashboardComponent, CreateWorkspaceComponent, WorkspaceDetailsComponent, WorkspaceInsightsComponent, EditWorkspaceComponent, SubscriptionPlanComponent, CreateSubsciptionPlanComponent],
  imports: [UiComponentsModule, RouterModule, CommonModule, DragDropModule, ReactiveFormsModule, CdkTableModule, NgChartsModule, CurrencyPipe],
  providers: [],
  exports: [ToolTipDirective],
})
export class DashboardModule { }
